import React, { useEffect } from 'react';
import { AppProvider } from '@shopify/polaris';
import { SVGIcon } from '@superops/super-icons';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { TicketClient } from '@nile/graphql';
import { GET_ACTIVE_CONVERSATION_THREAD } from '@nile/components/src/Pages/SystemTrayChatPage/graphql';
import { EventEmitter, COMMON_CONSTANTS } from '@nile/components';
import { getState } from '@nile/components/src/Managers/StateManager';
import { useChatFeatureEnabled } from '@nile/components/src/Pages/SystemTrayChatPage/utils';
import SystemTrayChatWrapper from '@nile/components/src/Components/SystemTrayChatWrapper';
import theme from '../Config/Constants/theme';

function ApplicationLayout({ routeComponent: RouteComponent, children }) {
  const flags = useFlags();
  const isChatAvailable = useChatFeatureEnabled();

  const getActiveConversations = () => {
    const activeGlobalChat =
      getState('globalState')?.['globalConversation.activeChat'] || null;
    if (!activeGlobalChat) {
      TicketClient.query({
        query: GET_ACTIVE_CONVERSATION_THREAD,
        fetchPolicy: COMMON_CONSTANTS.CACHE_POLICIES.NO_CACHE,
        variables: null
      }).then((res) => {
        const convData = res?.data?.getActiveConversationThread;
        if (convData && convData?.status !== 'CLOSED') {
          const CHAT_PARAMS = {
            id: 'agentChatWindow',
            module: 'TICKET',
            data: {
              ...convData?.workItem,
              id: convData?.workItem?.workId,
              workId: convData?.workItem?.workId,
              module: 'TICKET',
              page: 'DETAILS'
            },
            type: 'CHAT',
            component: SystemTrayChatWrapper,
            hasAdditionalProps: true,
            chatData: {
              ...convData
            },
            subpage: 'TICKET',
            resumeChat: true
          };
          EventEmitter.dispatch('createGlobalConversation', CHAT_PARAMS);
        }
      });
    }
  };

  useEffect(() => {
    if (
      flags?.agentChatFe &&
      isChatAvailable &&
      !window.location.hash.includes('#/systray/')
    ) {
      getActiveConversations();
    }
  }, [flags]);

  return (
    <AppProvider
      theme={theme}
      i18n={{
        Polaris: {
          Avatar: {
            label: 'Avatar',
            labelWithInitials: 'Avatar with initials {initials}'
          },
          Frame: { skipToContent: 'Skip to content' },
          TopBar: {
            toggleMenuLabel: 'Toggle menu',
            SearchField: {
              clearButtonLabel: 'Clear',
              search: 'Search'
            }
          }
        }
      }}
    >
      {children}
      <div className="MainPage">{RouteComponent}</div>
      {flags?.aiHelpChat && (
        <div
          className="sopsLauncher"
          onClick={() => {
            window.CommandBar.toggleHelpHub();
          }}
        >
          <div className="launcherIcon">
            <SVGIcon name="CommandBarActivator" size="lg" color="#fff" />
          </div>
        </div>
      )}
    </AppProvider>
  );
}
export default ApplicationLayout;
